import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { TransactionsRevisionsReasonsService } from '../../transactions/_services/transactions-revision-reasons.service';
import { TransactionsRevisionReasonsDetailComponent } from '../transactions-revision-reasons-detail/transactions-revision-reasons-detail.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-transactions-revision-reasons-list',
    templateUrl: './transactions-revision-reasons-list.component.html',
    styleUrls: ['./transactions-revision-reasons-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TransactionsRevisionReasonsListComponent implements OnInit {
  public transactionsRevisionReasons: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private transactionsRevisionReasonsService: TransactionsRevisionsReasonsService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private loginService: LoginService,
    private dialogService: DialogService
  ) {
    this.allowWrite = this.loginService.hasPermission("TRANSACTIONS_REVISION_REASONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRANSACTIONS_REVISION_REASONS.DELETE");
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Razón de revisión de transacciones");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.transactionsRevisionReasonsService.all(params));
    this.transactionsRevisionReasons = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(transactionsRevisionReasons: any) {
    //this.router.navigate(['transactionsRevisionReasons/' + (transactionsRevisionReasons && Object.keys(transactionsRevisionReasons).length > 0 ? transactionsRevisionReasons.id : 0)]);

    let ref = this.dialogService.open(TransactionsRevisionReasonsDetailComponent, {
          closable: true,
          modal: true,
          header: 'Añadir razón de revisión de transacción',
          width: '30%', 
          draggable: true,         
          data: {
            id: transactionsRevisionReasons ? transactionsRevisionReasons.id : 0
          }
        });
    
        ref.onClose.subscribe((data: any) => {
          this.loadData(this.lastGridEvent);
        });
  }

  delete(transactionsRevisionReasons: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la razón "+transactionsRevisionReasons.name+"?",
        header: "Eliminar razón",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsRevisionReasonsService.delete(transactionsRevisionReasons.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Razón de revisión eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
  
}
